import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { "Content-Type": "application/json" },
});

/** Turn a stored media path (/api/media/xxx) into an absolute, loadable URL. */
export function mediaUrl(path, width) {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  // Originals are the owner's raw camera files (up to 25 MB). Ask the backend
  // for a cached, resized WebP whenever a display width is known.
  const q = width ? `${path.includes("?") ? "&" : "?"}w=${width}` : "";
  if (path.startsWith("/api/")) return `${BACKEND_URL}${path}${q}`;
  return `${BACKEND_URL}/api/media/${path}${q}`;
}

const TOKEN_KEY = "nq_admin_token";

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

api.interceptors.request.use((config) => {
  const t = tokenStore.get();
  if (t && config.url && config.url.includes("/admin")) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  if (t && config.url && config.url.includes("/auth/me")) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export const adminApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { "Content-Type": "application/json" },
});

adminApi.interceptors.request.use((config) => {
  const t = tokenStore.get();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default api;
